import { DraggerInput, FormItem } from '@framework/form';
import { message } from 'antd';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import { Geometry } from 'ol/geom';
import * as React from 'react';
import { useWatch } from 'react-hook-form';
import { Subject } from 'rxjs';
import { MapSubjectEvent } from '../../MapWidgetComponent';
import { MapUploadGeometriesType } from './MapUploadGeometriesSchema';

export interface IMapUploadGeometriesGeoJSONInputProps {
  mapSubject: React.RefObject<Subject<MapSubjectEvent>>;
  onClose: () => void;
}

const geoJSON = new GeoJSON({ featureProjection: 'EPSG:3857' });

async function parseGeoJSON(file: File) {
  return new Promise<Array<Feature<Geometry>>>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      try {
        const parsed = geoJSON.readFeatures(reader.result as string);
        resolve(parsed);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = reject;
  });
}

export function MapUploadGeometriesGeoJSONInput(
  props: IMapUploadGeometriesGeoJSONInputProps,
) {
  const { mapSubject } = props;

  const selectedType: MapUploadGeometriesType | null = useWatch({
    name: 'type',
  });

  if (selectedType !== MapUploadGeometriesType.GeoJSON) return null;

  return (
    <FormItem name="files" label="File">
      <DraggerInput
        accept={'application/json'}
        info="È possibile caricare un file in formato GeoJSON."
        beforeUpload={async (file, fileList) => {
          console.log(file, fileList);
          try {
            const parsed = await parseGeoJSON(file);
            console.log(`Parsed geoJSON:`, parsed);
            mapSubject.current?.next({
              type: 'upload',
              features: parsed,
            });
            props.onClose();
          } catch (error) {
            message.error('Errore durante la lettura del file GeoJSON');
            console.error(error);
          }
          return false;
        }}
      />
    </FormItem>
  );
}
